<app-layout [isProducerArea]="true">
  <app-page-header
    [title]="'Eventos favoritos'"
    [titleIcon]="'pi pi-sparkles'"
    [subtitle]="'Gerencie seus eventos favoritos.'"
    [breadcrumbs]="[
      { label: 'Início', link: '/', icon: 'pi pi-home' },
      { label: 'Eventos favoritos', icon: 'pi pi-sparkles' },
    ]">
  </app-page-header>
  <ng-container>
    <app-my-favorite-events
      [events]="activeEvents$ | async"
      [meta]="activeMeta$ | async"
      [pastEvents]="pastEvents$ | async"
      [pastMeta]="pastMeta$ | async"
      (loadMoreActivesClick)="handleLoadMoreActivesClick($event)"
      (loadMorePastEventsClick)="handleLoadMorePastEventsClick($event)" />
  </ng-container>
</app-layout>
